import { render } from "./form.vue?vue&type=template&id=c2de3494&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=c2de3494&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c2de3494"

export default script